import React, { useState } from "react";
import { FORM_FIELDS } from "../../Constants";
import Stepper from "../../components/Stepper";
import AddPriceListModal from "./AddPriceListModal";
import { Accordion } from "react-bootstrap";
import StoreCard from "./StoreCard";

const StorePriceListData = ({
  stepState,
  previousPage,
  nextPage,
  formData,
}) => {
  const { STORE_DATA, CLIENT_DATA } = FORM_FIELDS;
  const [stores, setStores] = useState(formData[STORE_DATA.name] || []);
  const [storesErrors, setStoresErrors] = useState([]);
  const [priceListModalData, setPriceListModalData] = useState(null);
  const [activeKey, setActiveKey] = useState(
    stores?.[0]?.[STORE_DATA.TAG.name]
  );

  const onNextPage = async () => {
    const invalidRows = [];
    setStoresErrors([]);
    stores.forEach((x) => {
      if (x.invalidRows) {
        invalidRows.push(
          <p className="m-0">{`Prodajno mjesto: ${x[STORE_DATA.DESCRIPTION.name]
            } / ${x[STORE_DATA.TAG.name]} / ${x[STORE_DATA.STREET.name]} ${x[STORE_DATA.STREET_NUMBER.name]
            } `}</p>
        );
      }
    });

    if (invalidRows.length > 0) {
      setStoresErrors(invalidRows);
      return;
    }
    nextPage({ [STORE_DATA.name]: stores });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <h1 className="my-4 text-center">Upute</h1>
          <p>
            Na{" "}
            <a href="https://digitalno-poslovanje.hrvatskitelekom.hr/Business/Predlo%C5%BEak_cjenik_Premium%20fiskalna%20blagajna.xlsx">
              poveznici
            </a>{" "}
            preuzmite obrazac za unos cjenika. Popunjeni obrazac cjenika
            očitajte prilikom dodavanja prodajnog mjesta u sekciju Cjenik
          </p>
          <p>
            Ili ako nemate cjenik nastavite s popunjavanjem podataka,a cjenik
            dostavite naknadno na e-mail adresu: korisnik.pfb@t.ht.hr. U mailu
            naznačiti Oib i naziv poslovnog subjekta.
          </p>
        </div>
        <div className="col-lg-12">
          <div>
            Objašnjenje značenja kolona u cjeniku
            <table className="table table-striped mt-3">
              <thead>
                <tr>
                  <td>{"Kolona"}</td>
                  <td>{"Objašnjenje"}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{"Naziv"}</td>
                  <td>{"Predstavlja naziv proizvoda koji se dodaje"}</td>
                </tr>
                <tr>
                  <td>{"Kod"}</td>
                  <td>
                    {
                      "Označava kod proizvoda, nije obavezan, ali ako je popunjen ne smije se ponoviti."
                    }
                  </td>
                </tr>
                <tr>
                  <td>{"Barkod"}</td>
                  <td>
                    {
                      "Označava bar kod proizvida, nije obvezan, ali ako je popunjen ne smije se ponoviti"
                    }
                  </td>
                </tr>
                <tr>
                  <td>{"Opis proizvoda"}</td>
                  <td>{"Označava opis artikla, nije obvezan"}</td>
                </tr>
                <tr>
                  <td>{"Usluga"}</td>
                  <td>
                    {
                      "Označava je li proizvod usluga; dopuštene vrijednosti: Da, Ne"
                    }
                  </td>
                </tr>
                <tr>
                  <td>{"Povratna naknada"}</td>
                  <td>
                    {
                      "Označava povratnu naknadu, obvezan podatak, ako nema porezne naknade postaviti 0, a ako postoji postaviti 0.07."
                    }
                  </td>
                </tr>
                <tr>
                  <td>{"Mjerna jedinica"}</td>
                  <td>{"Postaviti dopuštenje vrijednosti mjerne jedinice"}</td>
                </tr>
                <tr>
                  <td>{"Porezna stopa"}</td>
                  <td>
                    {
                      "Postaviti iznos porezne stope.Dopuštene vrijednosti PDV 25, PDV 13, PDV 5 i prazno."
                    }
                  </td>
                </tr>
                <tr>
                  <td>{"Grupa artikla"}</td>
                  <td>{"Označava grupu artikla"}</td>
                </tr>
                <tr>
                  <td>{"Cijena"}</td>
                  <td>
                    {
                      "Označava jediničnu cijenu proizvoda. Format x.xx. Nije potrebno unositi valutu."
                    }
                  </td>
                </tr>
                <tr>
                  <td>{"Pp"}</td>
                  <td>
                    {
                      "Označava porez na potrošnju. Ako nema, postaviti 0. Pripaziti i ne zamijeniti sa PDV. Maximalan iznos poreza za potrošnju može biti 3%."
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <h4> Lista prodajnih mjesta</h4>
      <Accordion
        activeKey={activeKey}
        style={{ margin: "20px 0" }}
        className={`public-onboarding-accordion`}
      >
        {stores.map((data, index) => (
          <StoreCard
            data={data}
            key={index}
            Accordion={Accordion}
            setStores={setStores}
            activeKey={activeKey}
            setActiveKey={setActiveKey}
            taxObligation={
              formData?.[CLIENT_DATA.name]?.[CLIENT_DATA.TAX_OBLIGATION.name]
            }
          />
        ))}
      </Accordion>
      {storesErrors?.length > 0 && (
        <div className="invalid-record my-3 p-3">{storesErrors}</div>
      )}

      <Stepper
        stepState={stepState}
        previousPage={previousPage}
        nextPage={onNextPage}
      />

      <AddPriceListModal
        updateData={priceListModalData}
        setStores={setStores}
        onHide={() => {
          setPriceListModalData(null);
        }}
      />
    </>
  );
};

export default StorePriceListData;
